import Toolbar from 'emerald-ui/lib/Toolbar';
import SearchForm from 'emerald-ui/lib/SearchForm';
import Button from 'emerald-ui/lib/Button';
import Icon from 'emerald-ui/lib/Icon';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Toolbar, componentName: 'Toolbar' }], 'Toolbar', Toolbar.View, 'ToolbarView'),
  description: 'A Toolbar contains a series of common actions. It generally goes above a Table.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Button, Icon, SearchForm, Toolbar },
      code: `<div style={{ overflow: 'auto' }}>
  <Toolbar activeView="default">
    <Toolbar.View id="default">
      <SearchForm clearable />
      <Button>
        Filter (2) <span className="caret" ariaLabel="Filter"/>
      </Button>
      <Button>
        <Icon name="exit_to_app" aria-hidden="true" />
        <span>Export</span>
      </Button>
      <Button>
        <Icon name="file_upload" aria-hidden="true" />
        <span>Bulk upload</span>
      </Button>
    </Toolbar.View>
    <Toolbar.View id="selection" color="info">
      <div className="eui-toolbar-text eui-toolbar-fill">
        <button
          style={{ border: 'none', background: 'none', padding: 0 }}
          className="eui-toolbar-link"
          onClick={this.handleOnClick}
        >
          2 items selected
        </button>
      </div>
      <Button shape="flat">Activate</Button>
      <Button shape="flat">Remove</Button>
    </Toolbar.View>
  </Toolbar>
</div>`,
    },
  ],
};
